export const kanbanAssessmentFilter = [
  "All",
  "Accepted",
  "Pending",
  "Submitted",
];

export const kanbanInterviewFilter = [
  "All",
  "Scheduled",
  "Pending",
  "Completed",
];

export const kanbanOfferFilter = ["All", "Accepted", "Rejected", "Pending"];
